
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface SkillsAddFormProps {
  newSkill: string;
  setNewSkill: (skill: string) => void;
  handleAddSkill: () => void;
}

export const SkillsAddForm = ({ newSkill, setNewSkill, handleAddSkill }: SkillsAddFormProps) => {
  return (
    <>
      <Input
        value={newSkill}
        onChange={(e) => setNewSkill(e.target.value)}
        placeholder="Enter skill name"
        className="text-sm"
        onKeyDown={(e) => e.key === 'Enter' && handleAddSkill()}
      />
      <Button 
        size="sm" 
        className="mt-2"
        onClick={handleAddSkill}
        disabled={!newSkill.trim()}
      >
        Add
      </Button>
    </>
  );
};
